export const dismissNudgeTooltip = "savlNe";
export default {dismissNudgeTooltip};